import React from "react";
import PageShell from "../components/PageShell";
import PageHero from "../components/PageHero";
import Process from "../components/Process";
import Testimonials from "../components/Testimonials";
import CallToAction from "../components/CallToAction";

export default function ProcessPage() {
  return (
    <PageShell>
      <PageHero
        eyebrow="◇ Process"
        title="How we work."
        accent="work."
        kicker="A deliberate, four-stage operating system that turns ambitious ideas into measurable, defensible software."
      />
      <Process />
      <Testimonials />
      <CallToAction
        eyebrow="◇ Engage"
        title="Like the way we work?"
        body="The first 30 minutes are on us. Pick a slot and bring your hardest problem."
        ctaLabel="Book a call"
      />
    </PageShell>
  );
}
